document.addEventListener('DOMContentLoaded', function(){
  const mql = window.matchMedia('(max-width: 768px)');
  const handleMediaQuery = function(mql) {
    if (!mql.matches) {
      const parallaxContainersPc = document.querySelectorAll('.aboutus-parallax-column__container__image');
      parallaxColumns(parallaxContainersPc);
    }
  };

  mql.addListener(handleMediaQuery);
  handleMediaQuery(mql);

  function parallaxColumns (containers) {
    containers.forEach((container, index) => {
      const image = container.querySelector('img');

      // スクロールイベントのリスナーを追加
      window.addEventListener('scroll', () => {
        const containerRect = container.getBoundingClientRect();

        // 要素がビューポートに入っているか確認
        if (containerRect.top < window.innerHeight && containerRect.bottom > 0) {
          // 各画像がビューポートに入った時点での位置を基にtranslateYを動的に計算
          const visibleRatio = (window.innerHeight - containerRect.top) / window.innerHeight;

          // 画像のサイズや配置に基づいて動的にtranslateYを計算
          const translateY = visibleRatio * (container.offsetHeight * 0.1); // 画像の高さに応じて動的に設定
          image.style.transform = `translateY(-${translateY}px)`;
        }
      });
    });
  }
});
